<template>
  <button class="culculation-request__button" :disabled="disabled">
    <span>
      <slot name="text" />
    </span>
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill="currentColor"
        d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
      ></path>
    </svg>
  </button>
</template>

<script>
export default {
  name: "CalculcationRequestFormButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
